import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SortFilterConfigModel } from 'src/app/shared/models/shared.model';
import { sortFilterConfig } from '../housekeeping/const';
import { Router } from '@angular/router';
import { GlobalServices } from 'src/app/shared/services/global.services';
import { RestfullServices } from 'src/app/shared/services/restfull.services';
import { TaskManagerCreateComponent } from '../task-manager-create/task-manager-create.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { forkJoin } from 'rxjs';
import { SnackBarComponent } from 'src/app/shared/components/snack-bar/snack-bar.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { element } from 'protractor';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-task-manager',
  templateUrl: './task-manager.component.html',
  styleUrls: ['./task-manager.component.scss']
})
export class TaskManagerComponent implements OnInit {

  @ViewChild('department') departmentSelect: any;
  @ViewChild('responsiblePerson') responsibleSelect: any;
  @ViewChild('taskStatus') statusSelect: any;
  @ViewChild('priority') prioritySelect: any;


  @ViewChild("taskTable", { static: false }) sort: MatSort;
  @ViewChild("taskListDataPaginator") set taskListDataPaginator(
    pager: MatPaginator
  ) {
    if (pager) this.dataSource.paginator = pager;
  }

  public displayedColumns: string[] = [
    "id",
    "taskName",
    "departmentName",
    "responsiblePerson",
    "priority",
    "toBeDoneBy",
    "escalated",
    "statusName"
  ];
  public searchValue: boolean = false;
  public search = '';
  public activeTableIndex = 0;
  public pageIndex = 0;
  public dataSource = new MatTableDataSource<any>();
  public transactionsForm = new UntypedFormGroup({
    name: new UntypedFormControl(),
    taskId: new UntypedFormControl(),
    title: new UntypedFormControl(),
    department: new UntypedFormControl(),
    responsiblePerson: new UntypedFormControl(),
    priority: new UntypedFormControl(),
    escalated: new UntypedFormControl(),
    dueDate: new UntypedFormControl(),
    taskStatus: new UntypedFormControl()
  });
  public responsiblePersonsList: any = [];
  public departmentList: any = [];
  public priorityList: any = [];
  public taskStatusList: any = [];
  public tasks: any;
  public tmProHotelId: number;

  isValueInFilterForm: boolean = false;
  public taskDataList: any = [];
  constructor(private router: Router, public globalService: GlobalServices, public restfullServices: RestfullServices, public dialog: MatDialog, public cdr: ChangeDetectorRef, private snackBar: MatSnackBar) { }

  ngOnInit(): void {
    this.globalService.headerData$.next({
      headerTitle: "Tasks",
      showBackButton: false,
    });
    this.tmProHotelId = +localStorage.getItem('selectedTmProHotelId');
    // this.taskDataList = [{ taskId: 1, title: "Air condition is not functioning", department: "Maintenance & Engineering", responsiblePerson: "Kara Fischer", dueDate: "19/09/2025", escalated: "Yes", taskStatus: "In-Work" },
    // { taskId: 2, title: "Re-stock Inventory", department: "Food & Beverage", responsiblePerson: "Doe Fischer", dueDate: "12/09/2025", escalated: "No", taskStatus: "Open" },
    // { taskId: 3, title: "Air condition is not functioning", department: "Maintenance & Engineering", responsiblePerson: "Kiara dube", dueDate: "20/09/2025", escalated: "Yes", taskStatus: "In-Work" },
    // { taskId: 4, title: "Massage Service", department: "Spa & Wellness", responsiblePerson: "Kara Fischer", dueDate: "19/08/2025", escalated: "No", taskStatus: "Dispatched" },
    // { taskId: 5, title: "Fix bathroom lights", department: "Maintenance & Engineering", responsiblePerson: "Jemma Kyle", dueDate: "07/10/2025", escalated: "Yes", taskStatus: "Pending" }
    // ];
    //this.dataSource = this.taskDataList;
    this.getTaskList();
  }
  ngAfterViewInit() {

  }
  handlePageEvent(e: PageEvent) {
    this.pageIndex = e.pageIndex;
    this.restfullServices.setSessionStorage('taskCurrentPage', JSON.stringify(this.pageIndex));
  }

  getTaskList() {
    this.globalService.showLoader$.next(true);
    forkJoin({
      departments: this.restfullServices.getTaskDepartments(this.tmProHotelId),
      statuses: this.restfullServices.getTaskStatus(),
      users: this.restfullServices.getTaskAllResponsiblePerson(),
      priority: this.restfullServices.getTaskPriority(),
      tasks: this.restfullServices.getTasks(this.tmProHotelId)
    }).subscribe(({ departments, statuses, users, priority, tasks }) => {
      const departmentMap = new Map(departments.map(d => [d.id, d.text]));
      const statusMap = new Map(statuses.map(s => [s.id, s.text]));
      const userMap = new Map(users.map(u => [u.userId, u.firstName]));
      const priorityMap = new Map(priority.map(p => [p.id, p.text]));

      this.departmentList = departments;
      this.taskStatusList = statuses.map(element => ({ ...element, displayName: this.globalService.getDisplayStatus(element.text) }));
      this.responsiblePersonsList = users.map(u => ({
        ...u,
        fullName: `${u.firstName} ${u.lastName}`.trim()
      }));
      this.priorityList = priority;
      this.priorityList.pop();
      this.tasks = tasks.map(task => ({
        ...task,
        departmentName: departmentMap.get(task.tmProDepartmentId),
        statusName: statusMap.get(task.tmProStatusId),
        responsiblePersonName: userMap.get(task.responsiblePerson),
        priority: priorityMap.get(task.tmProPriorityId)
      }));
      this.dataSource = new MatTableDataSource(this.sortTasks(this.tasks));
      this.dataSource.sort = this.sort;
      const savedCurrentTaskPageIndex = this.restfullServices.getSessionStorage('taskCurrentPage');
      if (savedCurrentTaskPageIndex) {
        this.pageIndex = +savedCurrentTaskPageIndex;
      }

      //Update global new tasks count
      this.globalService.taskManagementCount = tasks.filter(x => x.tmProStatusId === 1).length;
      this.getFormsValue();
      this.globalService.showLoader$.next(false);
    });
  }

  filter = {
    responsiblePersonName: "",
    departmentName: "",
    statusName: "",
    priority: "",
    search: this.search
  };
  public get responsiblePerson() {
    return this.transactionsForm.get("responsiblePerson");
  }
  public get department() {
    return this.transactionsForm.get("department");
  }
  public get priority() {
    return this.transactionsForm.get("priority");
  }
  public get taskStatus() {
    return this.transactionsForm.get("taskStatus");
  }
  onResponsibleChange(element: any) {
    console.log('Selected responsible userId:', element.responsiblePersonUserId);

    const updatePayload = {
      id: element.id,
      hotelId: element.hotelId,
      tmProStatusId: element.tmProStatusId,
      categoryId: 5,
      tmProDepartmentId: element.tmProDepartmentId,
      created: element.created,
      closed: element.closed,
      taskOwner: element.taskOwner,
      isInternal: true,
      taskName: element.taskName,
      description: element.description,
      shortDescription: element.shortDescription,
      responsiblePerson: element.responsiblePerson,
      toBeDoneBy: element.toBeDoneBy,
      tmProPriorityId: element.tmProPriorityId,
      tags: "",
      location: element.location,
      isEscalate: element.isEscalate
    };
    this.updateTask(updatePayload);
  }
  updateTask(payload: any) {
    this.restfullServices.updateTask(payload).subscribe({
      next: async (response) => {
        if (response) {
          this.openSnackBar("Updated Successfully!");
          this.getTaskList();
        }
      },
      error: (err) => {
        console.error('Error saving task:', err);
        this.globalService.showLoader$.next(false);
      },
      complete: () => {
        this.globalService.showLoader$.next(false);
      }
    });
  }


  // sortTasks(tasks: any[]): any[] {
  //   const today = new Date();
  //   today.setHours(0, 0, 0, 0);

  //   return tasks.sort((a, b) => {
  //     const aIsNew = a.statusName === 'Open';
  //     const bIsNew = b.statusName === 'Open';

  //     const aDone = a.statusName === 'Closed';
  //     const bDone = b.statusName === 'Closed';

  //     const aDate = a.closed ? new Date(a.closed) : null;
  //     const bDate = b.closed ? new Date(b.closed) : null;

  //     if (aDate) aDate.setHours(0, 0, 0, 0);
  //     if (bDate) bDate.setHours(0, 0, 0, 0);

  //     const tomorrow = new Date(today);
  //     tomorrow.setDate(today.getDate() + 1);

  //     const aIsToday = aDate && aDate.getTime() === today.getTime();
  //     const bIsToday = bDate && bDate.getTime() === today.getTime();

  //     const aIsTomorrow = aDate && aDate.getTime() === tomorrow.getTime();
  //     const bIsTomorrow = bDate && bDate.getTime() === tomorrow.getTime();

  //     const aIsPast = aDate && aDate < today;
  //     const bIsPast = bDate && bDate < today;

  //     //New task

  //     if (aIsNew && !bIsNew) return -1;
  //     if (!aIsNew && bIsNew) return 1;

  //     // If both are NEW, apply date rules inside the group
  //     if (aIsNew && bIsNew) {

  //       // 1. Today first
  //       if (aIsToday && !bIsToday) return -1;
  //       if (!aIsToday && bIsToday) return 1;

  //       // 2. Tomorrow second
  //       if (aIsTomorrow && !bIsTomorrow) return -1;
  //       if (!aIsTomorrow && bIsTomorrow) return 1;

  //       // 3. Future dates ascending
  //       if (!aIsPast && !bIsPast) {
  //         return aDate.getTime() - bDate.getTime();
  //       }

  //       // 4. Past dates last (overdue)
  //       if (aIsPast && !bIsPast) return 1;
  //       if (!aIsPast && bIsPast) return -1;

  //       // Both past - sort normally
  //       return aDate.getTime() - bDate.getTime();
  //     }

  //     // NON-"NEW" TASKS SORTING

  //     // Overdue first
  //     // if (aIsPast && !bIsPast) return -1;
  //     // if (!aIsPast && bIsPast) return 1;
  //     if (aIsPast && !aDone && !(bIsPast && !bDone)) return -1;
  //     if (!(aIsPast && !aDone) && (bIsPast && !bDone)) return 1;

  //     // if (aIsToday && bIsToday) {
  //     //   if (aDone && !bDone) return 1;   // done goes below not-done
  //     //   if (!aDone && bDone) return -1;
  //     //   return aDate.getTime() - bDate.getTime();
  //     // }

  //     // 1. Today (NOT Done) → next priority
  //     if (aIsToday && !aDone && !(bIsToday && !bDone)) return -1;
  //     if (!(aIsToday && !aDone) && (bIsToday && !bDone)) return 1;

  //     //2. Tommorrow Not done
  //     if (aIsTomorrow && !aDone && !(bIsTomorrow && !bDone)) return -1;
  //     if (!(aIsTomorrow && !aDone) && (bIsTomorrow && !bDone)) return 1;

  //     // // If both Today NOT done → sort by time
  //     // if (aIsToday && bIsToday && !aDone && !bDone) {
  //     //   return aDate.getTime() - bDate.getTime();
  //     // }

  //     // 1. Today first
  //     if (aIsToday && !bIsToday) return -1;
  //     if (!aIsToday && bIsToday) return 1;

  //     // 2. Tomorrow second
  //     if (aIsTomorrow && !bIsTomorrow) return -1;
  //     if (!aIsTomorrow && bIsTomorrow) return 1;

  //     // 3. Upcoming (future) third
  //     if (!aIsPast && !bIsPast) {
  //       // both are future dates → sort ascending
  //       return aDate.getTime() - bDate.getTime();
  //     }

  //     // From here on, at least one is past.

  //     // 4. If both overdue (past)
  //     if (aIsPast && bIsPast) {

  //       // If one is Done → that one goes LAST
  //       if (aDone && !bDone) return 1;
  //       if (!aDone && bDone) return -1;

  //       // Otherwise both are overdue not Done → sort by date
  //       return aDate.getTime() - bDate.getTime();
  //     }

  //     // 5. One is past, one is not → upcoming wins
  //     if (aIsPast && !bIsPast) return 1;   // a goes down
  //     if (!aIsPast && bIsPast) return -1;  // b goes down

  //     // Future dates ascending
  //     return aDate.getTime() - bDate.getTime();
  //   });
  // }
  // sortTasks(tasks: any[]): any[] {
  //   const today = new Date();
  //   today.setHours(0, 0, 0, 0);

  //   return tasks.sort((a, b) => {
  //     const aIsNew = a.statusName === 'Open';
  //     const bIsNew = b.statusName === 'Open';

  //     const aDone = a.statusName === 'Closed';
  //     const bDone = b.statusName === 'Closed';

  //     const aDate = a.closed ? new Date(a.closed) : null;
  //     const bDate = b.closed ? new Date(b.closed) : null;

  //     if (aDate) aDate.setHours(0, 0, 0, 0);
  //     if (bDate) bDate.setHours(0, 0, 0, 0);

  //     const tomorrow = new Date(today);
  //     tomorrow.setDate(today.getDate() + 1);

  //     const aIsToday = aDate && aDate.getTime() === today.getTime();
  //     const bIsToday = bDate && bDate.getTime() === today.getTime();

  //     const aIsTomorrow = aDate && aDate.getTime() === tomorrow.getTime();
  //     const bIsTomorrow = bDate && bDate.getTime() === tomorrow.getTime();

  //     const aIsPast = aDate && aDate < today;
  //     const bIsPast = bDate && bDate < today;

  //     // ---------------------------------------------------------
  //     // 1️⃣ NEW TASKS SECTION
  //     // ---------------------------------------------------------
  //     if (aIsNew && !bIsNew) return -1;
  //     if (!aIsNew && bIsNew) return 1;

  //     if (aIsNew && bIsNew) {

  //       // Today first
  //       if (aIsToday && !bIsToday) return -1;
  //       if (!aIsToday && bIsToday) return 1;

  //       // Tomorrow second
  //       if (aIsTomorrow && !bIsTomorrow) return -1;
  //       if (!aIsTomorrow && bIsTomorrow) return 1;

  //       // Future (not past)
  //       if (!aIsPast && !bIsPast) {
  //         return aDate.getTime() - bDate.getTime();
  //       }

  //       // Past dates last → ascending
  //       return aDate.getTime() - bDate.getTime();
  //     }

  //     // ---------------------------------------------------------
  //     // 2️⃣ NON-NEW TASKS
  //     // Split into NOT DONE and DONE
  //     // ---------------------------------------------------------

  //     // 🔹 Case A — NOT DONE TASKS
  //     if (!aDone && !bDone) {

  //       // 1. Overdue (past) first (ascending)
  //       if (aIsPast && !bIsPast) return -1;
  //       if (!aIsPast && bIsPast) return 1;
  //       if (aIsPast && bIsPast) {
  //         return aDate.getTime() - bDate.getTime();
  //       }

  //       // 2. Today not done
  //       if (aIsToday && !bIsToday) return -1;
  //       if (!aIsToday && bIsToday) return 1;

  //       // 3. Tomorrow not done
  //       if (aIsTomorrow && !bIsTomorrow) return -1;
  //       if (!aIsTomorrow && bIsTomorrow) return 1;

  //       // 4. Future (ascending)
  //       return aDate.getTime() - bDate.getTime();
  //     }

  //     // 🔹 Case B — DONE TASKS
  //     if (aDone && bDone) {

  //       // 1. Today
  //       if (aIsToday && !bIsToday) return -1;
  //       if (!aIsToday && bIsToday) return 1;

  //       // 2. Tomorrow
  //       if (aIsTomorrow && !bIsTomorrow) return -1;
  //       if (!aIsTomorrow && bIsTomorrow) return 1;

  //       // 3. Future (ascending)
  //       if (!aIsPast && !bIsPast) {
  //         return aDate.getTime() - bDate.getTime();
  //       }

  //       // 4. Past (ascending) LAST
  //       return aDate.getTime() - bDate.getTime();
  //     }

  //     // ---------------------------------------------------------
  //     // Mixed case: one done, one not done → Not Done first
  //     // ---------------------------------------------------------
  //     if (!aDone && bDone) return -1;
  //     if (aDone && !bDone) return 1;

  //     return 0;
  //   });
  // }
  sortTasks(tasks: any[]): any[] {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return tasks.sort((a, b) => {
      const aIsNew = a.statusName === 'Open';
      const bIsNew = b.statusName === 'Open';

      const aDone = a.statusName === 'Closed' || a.statusName === 'Cancelled';
      const bDone = b.statusName === 'Closed' || b.statusName === 'Cancelled';

      const aDate = a.toBeDoneBy ? new Date(a.toBeDoneBy) : null;
      const bDate = b.toBeDoneBy ? new Date(b.toBeDoneBy) : null;

      if (aDate) aDate.setHours(0, 0, 0, 0);
      if (bDate) bDate.setHours(0, 0, 0, 0);

      const tomorrow = new Date(today);
      tomorrow.setDate(today.getDate() + 1);

      const aIsToday = aDate && aDate.getTime() === today.getTime();
      const bIsToday = bDate && bDate.getTime() === today.getTime();

      const aIsTomorrow = aDate && aDate.getTime() === tomorrow.getTime();
      const bIsTomorrow = bDate && bDate.getTime() === tomorrow.getTime();

      const aIsPast = aDate && aDate < today;
      const bIsPast = bDate && bDate < today;

      // ---------------------------------------------------------
      // 1️⃣ NEW TASKS SECTION
      // ---------------------------------------------------------
      if (aIsNew && !bIsNew) return -1;
      if (!aIsNew && bIsNew) return 1;

      if (aIsNew && bIsNew) {

        // Today first
        if (aIsToday && !bIsToday) return -1;
        if (!aIsToday && bIsToday) return 1;

        // Tomorrow second
        if (aIsTomorrow && !bIsTomorrow) return -1;
        if (!aIsTomorrow && bIsTomorrow) return 1;

        // Future → ASCENDING (unchanged for NEW)
        if (!aIsPast && !bIsPast) {
          return aDate.getTime() - bDate.getTime();
        }

        // Past → ASCENDING
        return aDate.getTime() - bDate.getTime();
      }

      // ---------------------------------------------------------
      // 2️⃣ NON-NEW TASKS
      // Split into NOT DONE and DONE
      // ---------------------------------------------------------

      // 🔹 Case A — NOT DONE TASKS (NON-NEW)
      if (!aDone && !bDone) {

        const getRank = (d: Date | null) => {
          if (!d) return Number.MAX_SAFE_INTEGER;

          if (d.getTime() === today.getTime()) return 0; // today
          if (d.getTime() === tomorrow.getTime()) return 1; // tomorrow

          const isPast = d < today;

          // future dates: rank 2+
          if (!isPast) {
            return 2 + (d.getTime() - tomorrow.getTime());
          }

          // past dates: push far down but still sorted among themselves
          return 1_000_000_000 + (today.getTime() - d.getTime());
        };

        return getRank(aDate) - getRank(bDate);
      }
      // // 🔹 Case A — NOT DONE TASKS
      // if (!aDone && !bDone) {

      //   // 1. Overdue → ASCENDING
      //   if (aIsPast && !bIsPast) return -1;
      //   if (!aIsPast && bIsPast) return 1;
      //   if (aIsPast && bIsPast) {
      //     return bDate.getTime() - aDate.getTime();
      //   }

      //   // 2. Today
      //   if (aIsToday && !bIsToday) return -1;
      //   if (!aIsToday && bIsToday) return 1;

      //   // 3. Tomorrow
      //   if (aIsTomorrow && !bIsTomorrow) return -1;
      //   if (!aIsTomorrow && bIsTomorrow) return 1;

      //   // 4. Future (ascending)
      //   return bDate.getTime() - aDate.getTime();
      // }

      // 🔹 Case B — DONE TASKS
      if (aDone && bDone) {

        const getRank = (d: Date | null) => {
          if (!d) return Number.MAX_SAFE_INTEGER;

          const time = d.getTime();

          if (aIsToday && time === today.getTime()) return 0;
          if (aIsTomorrow && time === tomorrow.getTime()) return 1;

          const isPast = d < today;

          // Future first (within done section)
          if (!isPast) {
            return 2 + time;
          }

          // Past goes last (but ordered)
          return 1_000_000_000 + (today.getTime() - time);
        };

        return getRank(aDate) - getRank(bDate);
      }
      // if (aDone && bDone) {

      //   // 1. Today
      //   if (aIsToday && !bIsToday) return -1;
      //   if (!aIsToday && bIsToday) return 1;

      //   // 2. Tomorrow
      //   if (aIsTomorrow && !bIsTomorrow) return -1;
      //   if (!aIsTomorrow && bIsTomorrow) return 1;

      //   // 3. Future → DESCENDING
      //   if (!aIsPast && !bIsPast) {
      //     return bDate.getTime() - aDate.getTime();
      //   }

      //   // 4. Past → DESCENDING (still bottom)
      //   return bDate.getTime() - aDate.getTime();
      // }

      // ---------------------------------------------------------
      // Mixed case: Not Done BEFORE Done
      // ---------------------------------------------------------
      if (!aDone && bDone) return -1;
      if (aDone && !bDone) return 1;

      return 0;
    });
  }

  isOverdue(task: any): boolean {
    if (!task.closed) return false;
    const date = new Date(task.closed);
    const today = new Date();
    date.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    return date < today && task.statusName !== 'Open';
  }
  getDisplayDate(dateString: string): string {
    if (!dateString) return '';

    const date = new Date(dateString);
    const today = new Date();
    const tomorrow = new Date();

    today.setHours(0, 0, 0, 0);
    tomorrow.setHours(0, 0, 0, 0);
    tomorrow.setDate(today.getDate() + 1);

    const closed = new Date(date);
    closed.setHours(0, 0, 0, 0);

    if (closed.getTime() === today.getTime()) {
      return 'Today';
    }

    if (closed.getTime() === tomorrow.getTime()) {
      return 'Tomorrow';
    }

    // Otherwise return formatted date
    //return closed.toLocaleDateString('en-GB'); // 31/10/2025 format
    return formatDate(closed, 'dd/MM/yyyy', 'en-GB');
  }

  applyFilter() {
    // Show or hide “Clear filter” link
    this.isValueInFilterForm = Object.values(this.filter).some(v => !!v);
    this.dataSource.filter = JSON.stringify(this.filter);
  }
  ngOnDestroy(): void {
    if (!this.router.url.includes('tasks')) {
      sessionStorage.removeItem('taskCurrentPage');
    }
  }
  createTask() {
    this.cdr.detectChanges();
    this.dialog.open(TaskManagerCreateComponent, {
      width: '860px',
      height: '630px',
      panelClass: ["share-link_container-task", "border-top"],
      data: {
        eventType: "isAdd",
      },
    }).afterClosed().subscribe((res) => {
      console.log('Dialog closed with result:', res);
      if (res.status === 'success') {
        // handle save success
        this.openSnackBar("Task successfully created!");
        sessionStorage.removeItem('taskCurrentPage');
        setTimeout(() => {
          this.getTaskList();
          this.getFormsValue();
        }, 1000); // reload after 2 seconds
      }
      else if (res === 'cancel') {
        // handle cancel action
        console.log('Task creation cancelled.');
      }
    });
  }
  onDepartmentSelect(event: any) {
    console.log('Department selection event:', event);
  }
  private openSnackBar(message: string) {
    this.snackBar.openFromComponent(SnackBarComponent, {
      panelClass: ['custom-snackbar'],
      horizontalPosition: 'right',
      verticalPosition: 'top',
      data: {
        svgIcon: 'check-circle',
        message
      }
    });
  }

  openTaskDetail(id: any) {
    this.router.navigate(["pages/tasks/task-manager-detail"], {
      queryParams: {
        id: id,
      }
    });
  }
  // searchFilter(value) {
  //   if (value) {
  //     this.searchValue = true;
  //   } else {
  //     this.searchValue = false;
  //   }
  // }
  searchFilter(value: string) {
    if (value) {
      this.searchValue = true;
    } else {
      this.searchValue = false;
    }
    this.search = value.trim().toLowerCase();

    // Combine your dropdown filters and the search filter
    const filterObj = {
      responsiblePersonName: this.filter.responsiblePersonName,
      departmentName: this.filter.departmentName,
      statusName: this.filter.statusName,
      search: this.search // new search field
    };

    this.dataSource.filter = JSON.stringify(filterObj);
  }
  // public get isValueInFilterForm(): boolean {
  //   return !!Object.keys(this.transactionsForm.value).find(
  //     (item) => !!this.transactionsForm.value[item]
  //   );
  // }

  getFormsValue() {
    this.dataSource.filterPredicate = (data: any, filter: string): boolean => {
      const filterObj = JSON.parse(filter);

      const matchesStatus = filterObj.statusName
        ? data.statusName?.toLowerCase().includes(filterObj.statusName.toLowerCase())
        : true;

      const matchesResponsible = filterObj.responsiblePersonName
        ? data.responsiblePersonName?.toLowerCase().includes(filterObj.responsiblePersonName.toLowerCase())
        : true;

      const matchesDepartment = filterObj.departmentName
        ? data.departmentName?.toLowerCase().includes(filterObj.departmentName.toLowerCase())
        : true;
      const matchesPriority = filterObj.priority
        ? data.priority?.toLowerCase().includes(filterObj.priority.toLowerCase())
        : true;

      const matchesSearch = filterObj.search
        ? (data.taskName?.toLowerCase().includes(filterObj.search) ||
          data.departmentName?.toLowerCase().includes(filterObj.search) ||
          data.responsiblePersonName?.toLowerCase().includes(filterObj.search) ||
          data.id?.toString().includes(filterObj.search))
        : true;

      return matchesStatus && matchesResponsible && matchesDepartment && matchesPriority && matchesSearch;
    };
  }

  resetFilter() {
    this.searchValue = false;
    this.transactionsForm.get('name')?.setValue('');
    this.filter = {
      responsiblePersonName: '',
      departmentName: '',
      statusName: '',
      priority: '',
      search: ''
    };
    this.search = '';

    this.isValueInFilterForm = false;
    this.applyFilter();

    this.departmentSelect?.reset?.();
    this.responsibleSelect?.reset?.();
    this.statusSelect?.reset?.();
    this.prioritySelect?.reset?.();
  }
  escalateStatus(status) {
    return status == true ? "Yes" : "No";
  }
}
